import React, { RefObject, useState } from "react"
import { Box, Flex } from "@chakra-ui/react"
import CountBadge from "components/elements/CountBadge"
import Float from "components/elements/Float"
import NavItem from "components/Navigation/NavItem"
import MegaphoneIcon from "./MegaphoneIcon"
import WhatsNewPanel from "./WhatsNewPanel"
import { usePrefetchUpdates, useUpdateDates } from "./queries"
import useWhatsNewSeenAt from "./useWhatsNewSeenAt"

type Props = {
  userId: string
  compact: boolean
  sidebarRef: RefObject<HTMLElement>
}

const WhatsNewNavItem = ({ userId, compact, sidebarRef }: Props) => {
  const { data: dates = [] } = useUpdateDates()
  const { isUnseen, markSeen } = useWhatsNewSeenAt(userId)
  const prefetchPosts = usePrefetchUpdates()
  const [panelLeft, setPanelLeft] = useState<number | null>(null)
  const unseenCount = dates.filter(({ publishedAt }) => isUnseen(publishedAt)).length

  const open = () => {
    if (dates.length) {
      markSeen(dates[0].publishedAt)
    }
    setPanelLeft((sidebarRef.current?.getBoundingClientRect().right ?? 0) + 16)
  }

  const badge = <CountBadge count={unseenCount} bg="red.500" aria-hidden />

  return (
    <>
      <Box w="full" color="gray.500" transition="color 0.15s ease-out" _hover={{ color: "gray.300" }}>
        <NavItem
          type="event"
          icon={(
            <Box as="span" display="block" position="relative">
              <MegaphoneIcon boxSize={5} display="block" />
              {compact && <Float placement="top-end" offset="2px">{badge}</Float>}
            </Box>
          )}
          title="What's New"
          compact={compact}
          aria-label={unseenCount ? `What's New, ${unseenCount} new` : "What's New"}
          onClick={open}
          onMouseEnter={prefetchPosts}
          onFocus={prefetchPosts}
          indicator={(
            <Flex position="absolute" top={0} right={2} h={10} pt={2} pb={1} align="center" pointerEvents="none">
              {badge}
            </Flex>
          )}
        />
      </Box>
      {panelLeft !== null && (
        <WhatsNewPanel left={panelLeft} onSeen={markSeen} onClose={() => setPanelLeft(null)} />
      )}
    </>
  )
}

export default WhatsNewNavItem
